import { DEFAULT_ATTRIBUTES, UID } from 'shared/api/query/constants';
import { aiChatSkill as aiChatSkillConfig, user as userConfig } from 'shared/api/query/configs.json';

export const children = [
  ...DEFAULT_ATTRIBUTES,
  { attr: aiChatSkillConfig.edges.title, default: '' },
  { attr: aiChatSkillConfig.edges.body, default: null },
  {
    attr: aiChatSkillConfig.edges.creator,
    model: userConfig.model,
    children: [{ attr: UID }],
    default: null,
  },
];
